import { render, staticRenderFns } from "./CustomerProfileCard.vue?vue&type=template&id=2f3fa03e&scoped=true"
import script from "./CustomerProfileCard.vue?vue&type=script&lang=js"
export * from "./CustomerProfileCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfileCard.vue?vue&type=style&index=0&id=2f3fa03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3fa03e",
  null
  
)

export default component.exports